export default "__VITE_ASSET__BAjy2xUE__"